export enum FetchPopupSearchParams {
    CategoryId = 'categoryId',
    TagId = 'tagId',
    BrandId = 'brandId',
    IsHomePage = 'isHomePage',
}

export enum PopupReactQueryKey {
    Popup = 'popup',
}

export const ModalClosedAtString = 'modalClosedAt_'
// @TODO: use dynamic urls
export const MobileImageUrl = 'https://cdn.khanoumi.com/develop/cml/popup/47/ad/47ad149543344eef8dd1d8cd30037a5f.png'
export const DesktopImageUrl = 'https://cdn.khanoumi.com/develop/cml/popup/d3/13/d3134333cec04161ac17e5823e58be20.png'
